<template>
  <div v-if="!password" class="pop-auth__hint">At least 8 characters.</div>
  <div v-else class="password-meter">
    <div class="password-meter__bars">
      <span
        v-for="i in 4"
        :key="i"
        class="password-meter__bar"
        :style="{ background: i <= score ? colors[score] : '#E4E4E4' }"
      ></span>
    </div>
    <div class="pop-auth__hint" style="margin-top: 5px">
      {{ words[score] }}<span v-if="password.length < 8"> (at least 8 characters)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordMeter',
  props: { password: { type: String, default: '' } },
  data() {
    return {
      colors: ['#E4E4E4', '#FF3939', '#FFB95A', '#22DC7C', '#25A97A'],
      words: ['', 'Weak', 'Okay', 'Good', 'Strong'],
    }
  },
  computed: {
    score() {
      const pw = this.password || ''
      return [pw.length >= 8, /[A-Z]/.test(pw), /\d/.test(pw), /[^A-Za-z0-9]/.test(pw)].filter(Boolean).length
    },
  },
}
</script>

<style scoped>
.password-meter { margin-top: 8px; }
.password-meter__bars { display: flex; gap: 4px; }
.password-meter__bar { flex: 1; height: 4px; border-radius: 2px; }
</style>
